var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02047 6.33759C10.0813 5.37044 11.5158 4.06241 11.6466 0.9375H12.5938V0H0.40625V0.9375H1.35341C1.48416 4.06241 2.91872 5.37044 3.97953 6.33759C4.69112 6.98637 5.09375 7.38347 5.09375 8C5.09375 8.61653 4.69112 9.01363 3.97953 9.66241C2.91872 10.6296 1.48416 11.9376 1.35341 15.0625H0.40625V16H12.5938V15.0625H11.6466C11.5158 11.9376 10.0813 10.6296 9.02047 9.66241C8.30888 9.01363 7.90625 8.61653 7.90625 8C7.90625 7.38347 8.30888 6.98637 9.02047 6.33759ZM6.03125 11.5137C5.88647 11.5436 5.74344 11.587 5.60384 11.6448L2.73269 12.8329C3.20156 11.6407 3.95675 10.9518 4.61116 10.3552C5.34147 9.68937 6.03125 9.06047 6.03125 8V11.5137ZM8.38884 10.3552C9.04325 10.9518 9.79841 11.6407 10.2673 12.8328L7.39616 11.6447C7.25656 11.587 7.11353 11.5435 6.96875 11.5137V8C6.96875 9.06047 7.65853 9.68937 8.38884 10.3552ZM2.71622 3.125C2.48956 2.53441 2.33303 1.82131 2.29206 0.9375H10.7079C10.6669 1.82131 10.5104 2.53441 10.2837 3.125H2.71622Z",
    fill: "#5566A9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.d0f47ba5.svg";
export { ForwardRef as ReactComponent };